// Default persona (matches the Senior Platform Engineer JSON exactly).
// Used as the fallback when no slug is present or the slug is unknown,
// and as the initial render before the slug-driven fetch resolves.
const defaultPersona = {
  slug: 'default',
  hero: {
    stackLine:
      'Cloud-native infrastructure, payment rails, AI integration pipelines, and event-driven backends. Built for production scale.',
    cvFile: '/cvs/TracyWankio_SeniorPlatformEngineer.pdf',
    cvLabel: 'pdf · senior platform engineer',
  },
  bio: {
    heading: 'SENIOR_PLATFORM_ENGINEER',
    paragraph:
      "I'm a software engineer. I've worked with Python, AWS, and GCP building infrastructure that serves 60+ enterprise clients, Coca-Cola and Naivas among them. 1,500+ transactions weekly. I lead teams, ship systems, and stay close to the code. Currently working on Reflex, a C++ framework I'm helping bring to the public.",
    diggingInto: [
      'LoRA fine-tuning and MCP server infrastructure for developer-facing AI assistants',
      'Cross-border stablecoin rails on Circle USDC with M-Pesa, MTN MoMo, and Airtel Money off-ramps',
      'Event-driven Kafka pipelines, idempotent state machines, and Kubernetes orchestration on AWS Fargate',
    ],
    expertise: [
      'Cloud Infrastructure',
      'Backend & APIs',
      'Event-Driven Systems',
      'DevOps & CI/CD',
      'Payment Rails',
      'AI Integration & MLOps',
    ],
    techIcons: ['python', 'typescript', 'aws', 'gcp', 'docker', 'kubernetes', 'kafka', 'postgres', 'mongodb', 'react', 'solidity'],
  },
  projects: {
    featuredOrder: ['LIPAWORLD', 'REFLEX MULTIMEDIA', 'ODAFLOW', 'ULULATE', 'CHESSIE', 'DOESTHISFLY'],
  },
};

export default defaultPersona;
